import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import EmailItemCard from "modules/Content/Shared/EmailItemCard";
import styled from "styled-components";
import {
  getEmailBrowserList,
  searchBrowserAssetsListInCampaign,
  resetEmailListInEmailBrowser,
  resetEmailBrowserInCampaignList,
} from "../actions";
// import HistorySearch from "../../CurationHistory/Components/HistorySearch";
import HistorySearch from "./HistorySearch";
import { searchBrowserAssetsList } from "../actions";
import BlogItemFourLoader from "modules/Common/Components/BlogItemFourLoader";
import { useLocation } from "react-router-dom";
import {
  getQueryAssetId,
  getQueryCampaignId,
  getQueryEmailId,
  getQueryVersionId,
} from "modules/EmailBrowser/utils";
import InfiniteLoader from "modules/Common/Components/InfiniteLoader";
import EmailItemLoader from "modules/Common/Components/EmailItemLoader";
// import CreateNewEmailButton from "modules/Common/Components/CreateNewEmailButton";
import ConfirmDialog from "../../Common/Components/ConfirmDialog";
import { EMAIL_BROWSER } from "../../../constants/actionTypes";
import { IArticlesItem } from "../../Content/interfaces";

interface IAssetsInCampaignSidebar {
  isCuratedSidebarOpen: boolean;
}

const EmailsListContainer: React.FC<IAssetsInCampaignSidebar> = (props: any) => {
  const dispatch = useDispatch();
  //* fetching asset Id to filter the asset from the All assets list
  const campaignId = getQueryCampaignId();
  const [search, setSearch] = useState(null);
  const emailId = getQueryEmailId();

  const page: number = useSelector((state: RootState) => state.emailBrowser?.emails?.page);
  const emails: any[] = useSelector((state: RootState) => state.emailBrowser?.emails?.data);
  const totalCount: number = useSelector((state: RootState) => state.emailBrowser?.emails?.totalCount);
  const emailsLoading: boolean = useSelector((state: RootState) => state.emailBrowser?.emails?.loading);
  const newEmailLoading: boolean = useSelector((state: RootState) => state.emailBrowser?.addNewEmail?.loading);
  const emptySearch: boolean = useSelector((state: RootState) => state.emailBrowser.searchFail);
  // const showCurationMessage = useSelector((state: RootState) => state.user.assets);
  const emailData = useSelector((state: RootState) => state.editionData);

  const [resolveRejectShowDialoge, setResolveRejectShowDialoge]: [any, any] = useState(undefined);
  const [showDeleteAssetDialoge, setShowDeleteAssetDialoge] = useState(false);
  const [currentEmailIndex, setCurrentEmailIndex] = useState(-1);

  // returns a promise for future state of confirm asset deletion dialoge
  const deletePromiseFuture = async () => {
    const promiseObj = new Promise((resolve, reject) => {
      setResolveRejectShowDialoge({
        res: resolve,
        rej: reject,
      });
    });
    return promiseObj;
  };

  useEffect(() => {
    if (resolveRejectShowDialoge && showDeleteAssetDialoge === false) {
      setShowDeleteAssetDialoge(true);
    }
  }, [resolveRejectShowDialoge]);

  //Triggered when user confirms the confirm dialoge of Email Deletion
  const emailDeleteHandler = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.res();
    setResolveRejectShowDialoge(undefined);
  };

  //Triggered when user cancels the confirm dialoge of Email Deletion
  const onConfirmDialogCancel = () => {
    setShowDeleteAssetDialoge(false);
    resolveRejectShowDialoge.rej();
    setResolveRejectShowDialoge(undefined);
  };

  const clearAssetSearch = () => {
    getEmailBrowserList();
  };

  const searchAssets = () => {
    if (search == null || search === "") {
      // getEmailBrowserList();
      loadMore();
    } else {
      searchBrowserAssetsList(search);
    }
  };

  const loadMore = () => {
    let params = {
      limit: 10,
      offset: emails.length,
    };
    getEmailBrowserList(params);
  };

  // const setSearchChangeMethod = (value: any) => {
  //   if(value.length )
  //   setSearch(value);
  // };

  // useEffect(() => {
  //   alert(campaignId);
  // }, []);

  // useEffect(() => {
  //   console.log("useEffect EmailBrowser : ", emailsLoading, emails.length);
  //   if (!emailsLoading && emails.length === 0) loadMore();
  //   return () => {};
  // }, []);

  useEffect(() => {
    if (emails.length === 0 && !emailsLoading) {
      loadMore();
    }
    return () => {
      resetEmailListInEmailBrowser();
      // resetEmailBrowserInCampaignList();
    };
  }, []);

  useEffect(() => {
    const index = findEmailIndex();
    if (index < 0 && emailData.editionId) {
      // not found in the list and emailData is not empty
      dispatch({
        type: EMAIL_BROWSER.ADD_EMAIL_DATA,
        payload: {
          emailId: emailData.editionId,
          name: emailData.editionName,
          subject: emailData.subject,
          articlesCount: emailData.curatedCount,
          campaignId: emailData.noCampaign ? null : emailData.assetId,
          campaignName: emailData.noCampaign ? null : emailData.digestName,
          thumbnails: emailData.editionArticles.map((item: IArticlesItem) => item?.image_url),
          lastUpdate: emailData.editionLastUpdate,
        },
      });
    }
  }, [emailData]);

  useEffect(() => {
    if (emailId && emails.length > 0) {
      setCurrentEmailIndex(findEmailIndex());
    } else {
      setCurrentEmailIndex(-1);
    }
  }, [emails, emailId]);

  function findEmailIndex(): number {
    return emails.findIndex((email) => email.emailId === emailId);
  }

  return (
    <Wrapper>
      {showDeleteAssetDialoge && (
        <DialogWrapper>
          <ConfirmDialog
            cancel="Cancel"
            confirm="Delete"
            onConfirm={emailDeleteHandler}
            onCancel={onConfirmDialogCancel}
            // icon={whiteRoy}
            title={"Are you sure you want to delete this email?"}
            titleQuestion={null}
          />
        </DialogWrapper>
      )}
      {/* {alreadyExistinDraft && <AlreadyExistPopup />} */}
      {/* <div className="your-assets margin-top-md padding-right-md">
        <h4 className="recent-heading">All Emails</h4>
        <span>
          <HistorySearch
            placeholder="Filter Assets"
            value={search}
            changeMethod={setSearch}
            clearMethod={clearAssetSearch}
            formSubmitMethod={searchAssets}
          />
        </span>
      </div> */}
      {/* {conditionRendering()} */}
      {/* <CreateNewEmailButton /> */}
      {/* {!showCurationMessage ? (
        <div className="your-assets margin-top-md padding-right-md">
          <h4 className="recent-heading">Drop articles to curate them to Emails</h4>
        </div>
      ) : null} */}
      <InfiniteLoader
        dataLength={emails.length}
        next={loadMore}
        hasMore={true}
        scrollableTarget="emailBrowserList"
        loader={
          emailsLoading ? (
            <div style={{ marginRight: "10px" }}>
              {[1, 2, 3, 4].map((item, index) => (
                <div key={index + item} className="margin-bottom-sm">
                  <EmailItemLoader />
                </div>
              ))}
            </div>
          ) : (
            <></>
          )
        }
      >
        <div className="all-assets-list">
          {newEmailLoading ? (
            <div className="margin-bottom-sm" style={{ marginRight: "10px" }}>
              <EmailItemLoader />
            </div>
          ) : null}
          {emails.length && currentEmailIndex !== -1 && currentEmailIndex < emails.length ? (
            <>
              <HeaderText>Current Email</HeaderText>
              <div
                key={emails[currentEmailIndex].emailId}
                className="margin-bottom-sm"
                style={{ marginRight: "10px" }}
              >
                <EmailItemCard
                  id={emails[currentEmailIndex].emailId}
                  active={true}
                  isCurrentEmail
                  data={emails[currentEmailIndex]}
                />
              </div>
            </>
          ) : null}
          {emailId ? (
            <AllEmailHeader>
              <HeaderText>All Emails</HeaderText>
              {/* <p>{totalCount > 0 ? totalCount - 1 : 0} emails</p> */}
            </AllEmailHeader>
          ) : null}
          {emails.map((item, key) => {
            if (item.emailId === emailId) return null;
            return (
              <div key={key} className="margin-bottom-sm" style={{ marginRight: "10px" }}>
                <EmailItemCard id={item.emailId} active={true} data={item} onDelete={deletePromiseFuture} />
              </div>
            );
          })}
        </div>
      </InfiniteLoader>
    </Wrapper>
  );
};

export default EmailsListContainer;

const Wrapper = styled.div`
  .all-assets-list {
    /* margin-top: 20px; */
    overflow-x: hidden;
    .no-results {
      color: gray;
      padding-top: 10px;
      padding-left: 10px;
    }
  }
  .recent-heading {
    font-family: "robotomedium", sans-serif;
    font-size: 18px;
    color: #67696a;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 5px;
    @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px;
    }
  }
`;
const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
`;

const AllEmailHeader = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: -10px;
  h6 {
    margin-bottom: 0;
  }
  p {
    color: rgba(30, 194, 82, 1);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: -0.29px;
    text-align: left;
    margin: 0;
    margin-left: 14px;
  }
`;

const HeaderText = styled.h6`
  color: rgba(103, 105, 106, 1);
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: -0.38px;
  text-align: left;
  margin: 0;
  margin-bottom: -10px;
`;
